var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerFeedbbackNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_7127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6714 3.27142H5.95714C5.60099 3.27142 5.25943 3.4129 5.00759 3.66474C4.75576 3.91657 4.61428 4.25813 4.61428 4.61428V16.7L3.27142 20.7286L8.64285 19.3857H19.3857C19.7418 19.3857 20.0835 19.2442 20.3352 18.9924C20.587 18.7406 20.7286 18.399 20.7286 18.0429V11.3286",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8305 13.5267L9.80194 14.2518L10.4734 10.1695L16.8251 3.84466C16.9499 3.7188 17.0984 3.6189 17.2621 3.55072C17.4257 3.48255 17.6012 3.44745 17.7786 3.44745C17.9558 3.44745 18.1313 3.48255 18.2949 3.55072C18.4586 3.6189 18.6071 3.7188 18.732 3.84466L20.1554 5.26809C20.2812 5.39292 20.3812 5.54145 20.4494 5.7051C20.5175 5.86872 20.5526 6.04425 20.5526 6.22152C20.5526 6.39879 20.5175 6.57431 20.4494 6.73795C20.3812 6.90159 20.2812 7.05011 20.1554 7.17495L13.8305 13.5267Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_7127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerFeedbbackNewSelected);
export default __webpack_public_path__ + "static/media/CustomerFeedbbackNewSelected.c92a5b11f7901ddc0aff910a7bd718b2.svg";
export { ForwardRef as ReactComponent };